import React from "react";
import { Headset, PhoneCall } from "lucide-react";
import { PHONES, toTel } from "../../mock";

const StickyBar = () => {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 bg-white border-t border-[#e6e9f0] shadow-[0_-4px_16px_rgba(20,40,76,0.10)] flex items-center" style={{ height: "var(--me-sticky-h)" }}>
      <div className="max-w-[1140px] w-full mx-auto px-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Headset className="h-5 w-5 shrink-0" style={{ color: "var(--me-blue)" }} aria-hidden="true" />
          <span
            className="text-[13px] sm:text-[15px] font-semibold truncate"
            style={{ color: "var(--me-heading)" }}
          >
            Parler à un conseiller énergie
          </span>
        </div>
        <a
          href={toTel(PHONES.conseiller)}
          data-testid="sticky-cta"
          aria-label={`Parler à un conseiller énergie, appeler le ${PHONES.conseiller}`}
          className="flex items-center gap-2 rounded-full px-4 sm:px-6 py-2 text-white text-[14px] sm:text-[15px] font-bold shrink-0 transition-colors"
          style={{ backgroundColor: "var(--me-blue)" }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--me-blue-hover)")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--me-blue)")}
        >
          <PhoneCall className="h-4 w-4" aria-hidden="true" />
          <span>Service Gratuit</span>
        </a>
      </div>
    </div>
  );
};

export default StickyBar;
